/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { ForgotPasswordMailForm } from '../../pages/common/forms/ForgotPasswordMailForm';
import { useApiRequestState } from '../../../utils/api.utils';

export const ForgotPasswordDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const [showLoader] = useApiRequestState('forgotPassword');

  const onClose = useCallback(() => {
    dispatch(closeDialog('forgotPasswordDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="forgotPasswordDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">Forgot password</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <ForgotPasswordMailForm />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="forgotPassword" formName="forgotPasswordMail-form" text="Send" color="##1BC3A7" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
